var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeys(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1.584)",
    stroke: "#000",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.473 5.634a3.734 3.734 0 0 0-3.422-3.718A3.733 3.733 0 0 0 2.803 9.25v3.817a.934.934 0 0 0 1.868 0V9.25a3.733 3.733 0 0 0 2.802-3.616z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98 9.332c.487-.068.957-.231 1.381-.481l3.056 3.052a.935.935 0 0 0 1.32-1.32L10.68 7.531a3.73 3.73 0 0 0-.56-4.522 3.74 3.74 0 0 0-4.52-.61"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.737,
    cy: 5.168,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.737 4.235V1.4a1.4 1.4 0 0 1 2.802 0v.615"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeys);
export default __webpack_public_path__ + "static/media/keys.92e56361d52c49fd7f6253b7b224e314.svg";
export { ForwardRef as ReactComponent };